const routes = {
  root: '/',
  login: {
    callback: '/login/callback',
    epic: '/login/epic'
  },
  logout: {
    callback: '/logout'
  },
  physician: {
    root: '/physician',
    dashboard: '/physician/dashboard',
    patientsList: '/physician/patients/list',
    patientDetail: (uuid: string) => `/physician/patients/${uuid}/*`,
    reviewTransmissions: '/physician/transmissions/review',
    reviewTransmission: (id: string) => `/physician/transmissions/${id}/review`,
    defaultTransmissionReport: `/physician/transmissions/report`,
    transmissionReportDetail: (id: string) => `/physician/transmissions/report/${id}`,
    editReport: '/physician/transmissions/edit',
    editReportById: (id: string) => `/physician/transmissions/${id}/edit`,
    loadReport: '/physician/transmissions/load',
    schedule: '/physician/schedule',
    tasks: '/physician/tasks',
    taskDetail: (id: string) => `/physician/tasks/${id}`,
    analytics: {
      root: '/physician/analytics',
      billing: '/physician/analytics/billing',
      accountOverview: '/physician/analytics/account-overview',
      alerts: '/physician/analytics/alerts',
      signatureStatus: '/physician/analytics/signature-status',
      batteryLife: '/physician/analytics/battery-life',
      deviceRecalls: '/physician/analytics/device-recalls',
      leadsRecalls: '/physician/analytics/leads-recalls'
    },
    inClinic: '/physician/in-clinic'
  },
  user: {
    root: '/user',
    settings: '/user/settings'
  }
};

export default routes;
